import { type FC } from "react";

import { Anchor } from "@mantine/core";

import { myLensesActionType } from "../../../analytics/event-creators";
import { useBlizzardEvents } from "../../../analytics/hooks";
import { type BlizzardEventData } from "../../../analytics/models";
import { LENS_PLUS_SUBSCRIPTION_URL } from "../../constants/externalLinks";
import { type SubmissionQuota, type SubmissionQuotaContext } from "../../models/SubmissionQuota";
import { shouldOfferLensPlusUpsell } from "../../utils/submissionQuota";

import { GetHigherLimitsWithLensPlus } from "./messages.generated";

const upsellClickEvent = {
    event: "MYLENSES_ACTION",
    actionType: myLensesActionType.click,
    label: "submission_quota_lens_plus_upsell_click",
    namespace: "lenses",
} as const satisfies BlizzardEventData;

const SubmissionQuotaUpsellLink: FC = () => {
    const { sendBlizzardEvent } = useBlizzardEvents();

    return (
        <Anchor
            size="xs"
            fw={500}
            underline="always"
            href={LENS_PLUS_SUBSCRIPTION_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
                sendBlizzardEvent(upsellClickEvent);
            }}
        >
            <GetHigherLimitsWithLensPlus />
        </Anchor>
    );
};

/** Split so the analytics hook (and its Recoil state) is only mounted when there is a link to show. */
export const SubmissionQuotaUpsell: FC<{ quota: SubmissionQuota; context: SubmissionQuotaContext }> = ({
    quota,
    context,
}) => (shouldOfferLensPlusUpsell(quota, context) ? <SubmissionQuotaUpsellLink /> : null);
